module.exports = __webpack_public_path__ + "img/Papeterie.4177ebfe.jpg";